/**
 * The screen never paginates: `rows` is fixed to the server maximum (200) and `orderByLastName` is the
 * only sort parameter the route accepts. `totalRecords` on the response is what lets the screen detect a
 * truncation past 200 contacts rather than silently dropping the rest.
 */
class FetchBeneficiaryContacts {
	constructor(
		public readonly facilityId: number,
		public readonly beneficiaryId: number,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		const queryParams = new URLSearchParams({
			page: '0',
			rows: '200',
			orderByLastName: 'ASC',
		});

		return queryParams.toString();
	}
}

export default FetchBeneficiaryContacts;
